import Editor from "@monaco-editor/react";
import React from "react";

/**
 * Monaco as a form control: it takes a value and hands back text, so it can be
 * a plain `<Field name=…>` child like any input.
 *
 * The frame is inline rather than in a stylesheet because callers override it —
 * antd's form theme borders nothing like Monaco's default does — and an inline
 * rule cannot be out-specified from CSS. `style` merges over the defaults.
 */
const MonacoEditorWrapper = ({
    value,
    onChange,
    readOnly = false,
    height = "400px",
    className,
    style,
}: {
    value?: string;
    onChange?: (value: string | undefined) => void;
    /**
     * Monaco is not an antd control, so it never sees the `disabled` a form
     * sets on its fields — a read-only form has to say so here.
     */
    readOnly?: boolean;
    height?: string | number;
    className?: string;
    style?: React.CSSProperties;
}) => {
    return (
        <div
            className={className}
            style={{
                border: '1px solid #d9d9d9',
                borderRadius: '2px',
                backgroundColor: '#fafafa',
                overflow: 'hidden',
                ...style,
            }}
        >
            <Editor
                height={height}
                defaultLanguage="plaintext"
                theme="vs-light"
                value={value}
                onChange={onChange}
                options={{
                    minimap: { enabled: false },
                    fontSize: 14,
                    wordWrap: 'on',
                    lineNumbers: 'off',
                    trimAutoWhitespace: false,
                    readOnly,
                }}
            />
        </div>
    );
};

export default MonacoEditorWrapper;
